import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { ShareModalService } from '../../../services/share-modal.service';
import { CloseModalComponent, ModalService } from '@uc/shared/ui';
import { FacebookV2SvgComponent, TwitterV2SvgComponent } from '@uc/shared/svg';

@Component({
	selector: 'uc-share-modal',
	templateUrl: './share-modal.component.html',
	imports: [CloseModalComponent, TwitterV2SvgComponent, FacebookV2SvgComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareModalComponent {
	window: Window & typeof globalThis;

	constructor(
		@Inject(DOCUMENT) private _document: Document,
		private _modalService: ModalService,
		private _shareService: ShareModalService,
	) {
		this.window = this._document.defaultView as Window & typeof globalThis;
	}

	closeModalPanel() {
		this._modalService.close();
	}

	onShare(platform: string) {
		if (platform === 'facebook') {
			const link = this._shareService.createShareLink(platform);
			this.window.open(link, 'sharer', 'toolbar=0,status=0,width=580,height=325');
			this.closeModalPanel();
			return;
		}
		const link = this._shareService.createShareLink(platform);
		this.window.open(link, 'sharer', 'toolbar=0,status=0,width=580,height=325');
		this.closeModalPanel();
	}
}
